/**
 * 用户端  申请评估
 */
 <template>
    <div class="login-page">
      <topInfo></topInfo>
      <cusNav></cusNav>
      <!-- 主体内容 -->
      <div class="eval-content" style="margin-bottom: 40px;">
         <div class="eval-con-top">
            <div class="eval-con-title"><span style="font-weight: 700;">丨</span>资料填写</div>
            <div style="display: flex;justify-content: flex-end;margin-left: auto;">
               <div class="eval-con-btn" @click="saveDrafts()">保存草稿</div>
               <div class="eval-con-btn" style="background-color: #FF8B36;" @click="systemEval()">智能评测</div>
               <div class="eval-con-btn" style="background-color: #FF8B36;" @click="agentEval()">专家评测</div>
            </div>
         </div>
         <div style="padding-bottom: 40px;">
            <el-form :model="applyForm" class="eval-form" label-width="120px" >
               <el-form-item label="专利名称：" class="required-label" prop="title">
                  <el-input size="small"  v-model.trim="applyForm.title" auto-complete="off" :placeholder="titleDesc" :style="{ '::placeholder':'color: #666666' }" clearable></el-input>
               </el-form-item>
               <el-form-item label="预申请类型：" class="required-label" prpo="type">
                  <div class="eval-type">
                     <div :class="applyForm.type=='发明专利'?'eval-type-active':'eval-type-item'" @click="checkType('发明专利')">发明专利</div>
                     <div :class="applyForm.type=='实用新型专利'?'eval-type-active':'eval-type-item'" style="margin-left: 40px;" @click="checkType('实用新型专利')">实用新型专利</div>
                  </div>
               </el-form-item>
               <el-form-item label="所属领域：" class="required-label" prop="area">
                  <div class="eval-area">
                     <div :class="applyForm.area=='机械'?'eval-area-active':'eval-area-item'" @click="checkArea('机械')">机械</div>
                     <div :class="applyForm.area=='电学'?'eval-area-active':'eval-area-item'" style="margin-left: 20px;" @click="checkArea('电学')">电学</div>
                     <div :class="applyForm.area=='通信'?'eval-area-active':'eval-area-item'" style="margin-left: 20px;" @click="checkArea('通信')">通信</div>
                     <div :class="applyForm.area=='生物'?'eval-area-active':'eval-area-item'" style="margin-left: 20px;" @click="checkArea('生物')">生物</div>
                     <div :class="applyForm.area=='光电'?'eval-area-active':'eval-area-item'" style="margin-left: 20px;" @click="checkArea('光电')">光电</div>
                     <div :class="applyForm.area=='化学'?'eval-area-active':'eval-area-item'" style="margin-left: 20px;" @click="checkArea('化学')">化学</div>
                     <div :class="applyForm.area=='材料'?'eval-area-active':'eval-area-item'" style="margin-left: 20px;" @click="checkArea('材料')">材料</div>
                  </div>
               </el-form-item>
               <el-form-item label="评估基准日：" class="required-unlabel" prop="appDate" style="text-align: left;">
                  <el-date-picker v-model="applyForm.appDate" type="date" formart="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择评估基准日期"></el-date-picker>
                  <span style="color: #8c939d;">（填写基准日后的申请评估将以基准日之前申请的专利文献作为基础，不填写默认为当前日期。）</span>
                  <!-- <el-input v-model="applyForm.appDate"></el-input> -->
               </el-form-item>
               <el-form-item label="技术摘要：" class="required-label" prop="abstract">
                  <el-input type="textarea" v-model="applyForm.abstract" :placeholder="abstractDesc"></el-input>
               </el-form-item>
               <el-form-item label="权利要求：（创新点）" class="required-label" prop="claim">
                  <el-input type="textarea" v-model="applyForm.claim" :placeholder="claimDesc" :style="{ '::placeholder':'color: #666666' }"></el-input>
               </el-form-item>
               <el-form-item label="技术方案：" class="required-label" prop="fullText">
                  <el-input type="textarea" v-model="applyForm.fullText" :placeholder="fullTextDesc"></el-input>
               </el-form-item>
               <el-form-item label="上传附图：" class="required-unlabel" style="text-align: left;">
                  <div style="display: flex;line-height: 20px;">
                     <div v-if="fileList&&fileList.length>0" class="preview_figure" style="display: flex;position: relative">
                        <div v-for="(item,index) in fileList" :key="index" style="position: relative">
                           <img :src="item.pre_figure_url" />
                           <div class="img-icon">
                              <i class="el-icon-zoom-in" style="display: inline-block;width: 28px;height: 28px;" title="预览" @click="preview(item)"></i>
                              <i class="el-icon-delete" style="display: inline-block;width: 28px;height: 28px;" title="删除" @click="delImg(index)"></i>
                           </div>
                        </div>
                     </div>
                     <el-upload
                        :action=uploadFigureAcyion
                        :headers=setHeader
                        :show-file-list="false"
                        :before-upload="beforeUploadFigure"
                        :on-success="handleUploadFigureSuccess">
                        <div style="width: 120px;height: 120px;border: 1px dashed #c0ccda;border-radius: 6px;">
                           <i class="el-icon-plus" style="font-size: 28px;color: #8c939d;margin-top: 46px;"></i>
                        </div>
                     </el-upload>
                  </div>
                  <span style="color: #999999;margin-top: -30px;">有相关附图可选择上传，没有可不传</span>
               </el-form-item>
            </el-form>
         </div>
      </div>
      <div class="order-confirm">
         <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="orderConfirmVisible" height="515px" width="770px">
         <div style="margin-top: -30px;">
            <div style="display: flex;align-items: center;">
               <img style="width: 60px;height: 60px;margin-right: 20px;" src="../../assets/eval/pay_head.png">
               <div style="height: 60px;display: flex;flex-direction: column;">
                  <div style="font-weight: 700;font-size: 18px;color: #333;line-height: 30px;margin-bottom: 10px;text-align: left;">支付界面</div>
                  <div style="font-size: 14px;color: #999;line-height: 20px;">请完善您的订单信息</div>
               </div>
            </div>
            <div class="pay_title">
               <div class="pay_title_bg"></div>
               <div>订单详情</div>
            </div>
            <div class="pay_order">
               <div class="pay_order_th">
                  <div style="width: 142px;">项目</div>
                  <div style="flex: 1;">评测方式</div>
                  <div style="width: 66px;text-align: right;">金额</div>
               </div>
               <div class="pay_order_tr">
                  <div style="text-align: center;">申请前预评估</div>
                  <div style="flex: 1;" v-if="orderForm.eval_type==1">智能评测</div>
                  <div style="flex: 1;" v-if="orderForm.eval_type==2">专家评测</div>
                  <div style="width: 66px;text-align: right;" v-if="orderForm.eval_type==1">{{ evaluate_fee }}</div>
                  <div style="width: 66px;text-align: right;" v-if="orderForm.eval_type==2">{{ evaluate_agent_fee }}</div>
               </div>
               <div class="order_count">
                  <div style="font-size: 14px;">合计</div>
                  <div style="font-size: 16px;color: #ff4242;" v-if="orderForm.eval_type==1">￥{{ evaluate_fee }}</div>
                  <div style="font-size: 16px;color: #ff4242;" v-if="orderForm.eval_type==2">￥{{ evaluate_agent_fee }}</div>
               </div>
            </div>
            <div class="pay_title">
               <div class="pay_title_bg"></div>
               <div>支付方式</div>
            </div>
            <div class="pay_type_box">
               <div class="pay_type_item">
                  <el-checkbox v-model="orderForm.pay_type" :true-label="2" :false-label="0" style="width: 187px;padding: 0 20px;align-items: center;height: 50px;justify-content: space-between;line-height: 50px;">
                     <div class="type_item-right" style="font-size: 14px;margin-left: 10px;">
                        <img style="width: 14px;margin-right: 4px;" src="../../assets/eval/pay_zhifubao.png">支付宝支付
                     </div>
                  </el-checkbox>
               </div>
               <div class="pay_type_item">
                  <el-checkbox v-model="orderForm.pay_type" :true-label="1" :false-label="0" disabled style="width: 187px;padding: 0 20px;align-items: center;height: 50px;justify-content: space-between;line-height: 50px;">
                     <div class="type_item-right" style="font-size: 14px;margin-left: 10px;">
                        <img style="width: 14px;margin-right: 4px;" src="../../assets/eval/pay_weixi.png">微信支付
                     </div>
                  </el-checkbox>
               </div>
               <div class="pay_type_jf">
                  积分余额：{{ points }}
               </div>
               <el-checkbox v-model="orderForm.is_use_points" :true-label="2" :false-label="1">优先使用积分</el-checkbox>
            </div>
            <div class="pay_btn">
               <el-button style="color: #fff;background-color: #008D9D;padding: 10px 20px;border-radius: 4px;cursor: pointer;" @click="commitOrder()">前往支付</el-button>
            </div>
         </div>
      </el-dialog>
      </div>
      <!-- 积分支付确认 -->
      <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="confirmPointsVisible" width="400px">
         <div class="pay_price" style="height: 300px">
            <div style="font-size: 16px;color: #333;font-weight: 700;margin-top: -10px;">订单支付</div>
            <div style="margin-top: 10px;margin-bottom: 20px;">积分全额抵扣</div>
            <div>消耗积分</div>
            <!-- <div>{{ orderResult.points }}</div> -->
            <div style="color: #ff2c2c;font-size: 16px;margin-top: 4px;">{{ orderResult.deduction_fee }}</div>
            <div style="margin-top: 20px;">抵扣金额</div>
            <!-- <div>￥{{ orderResult.deduction_fee }}</div> -->
            <div style="color: #b9b9b9;text-decoration: line-through;margin-top: 4px;">￥{{ orderResult.deduction_fee }}</div>
            <div class="pay_btn">
               <el-button style="color: #fff;background-color: #008D9D;padding: 10px 20px;border-radius: 4px;cursor: pointer;" @click="orderPayUsePoints()">积分支付</el-button>
            </div>
         </div>
      </el-dialog>
      <!-- 扫码支付 -->
      <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="orderCodeVisible" width="400px">
         <div class="pay_price">
            <div style="font-size: 16px;color: #333;font-weight: 700;margin-top: -10px;">订单支付</div>
            <div style="margin-top: 10px;margin-bottom: 20px;">请使用支付宝扫码支付</div>
            <img :src="orderResult.pay_code" style="width: 150px;height: 150px;margin-bottom: 40px;" />
            <div v-if="orderResult.deduction_fee > 0" style="color: #999999;margin-bottom: 20px;">
               <span>积分抵扣：</span>
               <span>￥{{ orderResult.deduction_fee }}</span>
            </div>
            <div style="margin-bottom: 20px;">
               <span>实际支付：</span>
               <span style="color: #ff2c2c;font-size: 16px;">￥{{ orderResult.total_fee }}</span>
            </div>
         </div>
      </el-dialog>

      <!-- 图片预览 -->
      <el-dialog :visible.sync="dialogVisible">
         <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>
    </div>
 </template>
 <script>
   import topInfo from '../../components/topInfo'
   import cusNav from '../../components/cusNav'
   import '../../assets/js/directive'
   import { 
      editCaseDrafts,
      getDraftsInfo,
      commitCase,
      createOrder,
      getOrderConfig,
      getUserInfo,
      orderPayByPoints,
      getOrderInfo,
      webUrl
   } from '../../api/evalMG'
   import { checkLogin } from '../../utils/util'
   export default {
      data() {
         return {
            title: '',
            orderConfirmVisible: false,
            // 积分支付确认页
            confirmPointsVisible: false,
            // 二维码扫码支付页
            orderCodeVisible: false,

            dialogVisible: false,
            dialogImageUrl: '',

            setHeader:{
               'token': localStorage.getItem('userToken')
            },
            // 附图上传地址
            uploadFigureAcyion: webUrl + '/admin/cases/uploadCaseFigure',

            fileList: [],
            applyForm : {
               id: '',
               title: '',
               type: '',
               area: '',
               abstract: '',
               claim: '',
               fullText: '',
               figureData: [],
               appDate: ''
            },
            orderForm: {
               case_id: '',
               total_fee: '',
               eval_type: '',
               pay_type: '',
               is_use_points: ''
            },
            // 定时器
            intervalId: null,
            // 订单结果数据
            orderResult: [],
            // 当前账户积分
            points: '',
            // 智能评估价格
            evaluate_fee: '',
            // 智能+专家评估价格
            evaluate_agent_fee: '',
            drafts_id: '',
            claimDesc: '核心创新点，产品的结构组成、化学组成，组分含量；方法的操作步骤、条件参数，工作过程等。',
            titleDesc: '简单而明了地反映该发明的技术内容是产品、装置或方法（不得含有非技术词语、一般限定在25个字符数内）。',
            abstractDesc: '描述现有技术及其存在的缺陷，说明本发明的目的（技术上而非经济、社会效益）或本发明所解决的技术问题，写明由本申请新增加的不可缺少的创新点所直接产生的新的有益效果（技术上而非经济、社会效益）。',
            fullTextDesc: '对权利要求中提出的创新点，以及产品整体的结构组成、化学组成、组分含量，方法的操作步骤、条件参数，工作过程等进行十分详细地说明，必要时应举多个实施例反映出发明创造所涵盖的所有可能方式。',
            
         }
      },
       // 注册组件
      components: {
         topInfo,
         cusNav
      },
      created(){

      },
      // 监听
      watch: {
         orderCodeVisible(val){
            if(val){
               console.log(val)
               this.startTimer()
            }
            if(!val){
               console.log(val)
               this.stopTimer()
            }
         }
      },
      mounted(){
         // console.log(this.$route.query.drafts_id)
         let drafts_id = this.$route.query.drafts_id
         if(drafts_id){
            this.getDraftsData(drafts_id)
         }
      },
      methods: {
         checkType(val){
            this.applyForm.type = val
         },
         checkArea(val){
            this.applyForm.area = val
         },
         // 保存草稿箱
         saveDrafts(){
            let figureData = this.applyForm.figureData
            if(figureData&&figureData.length>0){
               this.applyForm.figureData = JSON.stringify(figureData)
            }
            editCaseDrafts(this.applyForm)
            .then(res=>{
                res = checkLogin(res);
                if(!res){
                 this.$message({
                   type: 'warning',
                   message: '登录已失效,请重新登录!'
                 }) 
                  // 登陆已失效 清除登陆状态
                  setTimeout(() => {
                     window.localStorage.removeItem('userToken');
                     window.localStorage.removeItem('sign');
                     window.localStorage.removeItem('userData');
                     this.$router.push({ path: '/login'});
                     }, 1000)
                }
               if(res.code == 200){
                  // 保存成功
                  this.$message({
                    type: 'success',
                    message: '已保存至草稿箱!'
                 })
                 this.applyForm.id = ''
                 this.applyForm.title = ''
                 this.applyForm.type = ''
                 this.applyForm.area = ''
                 this.applyForm.abstract = ''
                 this.applyForm.claim = ''
                 this.applyForm.fullText = ''
               }else{
                 this.$message({
                    type: 'info',
                    message: res.msg
                 })
               }
            })
         },
         // 智能评测
         systemEval(){
            console.log(this.applyForm)
            let id = this.applyForm.id
            let title = this.applyForm.title
            let type = this.applyForm.type
            let area = this.applyForm.area
            let abstract = this.applyForm.abstract
            let claim = this.applyForm.claim
            let fullText = this.applyForm.fullText
            let appDate = this.applyForm.appDate
            if(title.length <= 0){
               this.$message({
                    type: 'warning',
                    message: '请填写专利名称!'
                 })
               return false
            }
            if(type.length <= 0){
               this.$message({
                    type: 'warning',
                    message: '请选择预申请类型!'
                 })
               return false
            }
            if(area.length <= 0){
               this.$message({
                    type: 'warning',
                    message: '请选择所属领域!'
                 })
               return false
            }
            if(abstract.length <= 0){
               this.$message({
                    type: 'warning',
                    message: '请填写技术摘要!'
                 })
               return false
            }
            if(claim.length <= 0){
               this.$message({
                    type: 'warning',
                    message: '请填写权利要求!'
                 })
               return false
            }
            if(fullText.length <= 0){
               this.$message({
                    type: 'warning',
                    message: '请填写技术方案!'
                 })
               return false
            }
            let figureData = this.fileList
            let figureDatas = []
            if(figureData&&figureData.length>0){
               figureData.forEach((item,index)=>{
                  figureDatas.push(item.figure_url)
               })
            }
            let param = {
               id: id,
               title: title,
               type: type,
               area: area,
               abstract: abstract,
               claim: claim,
               fullText: fullText,
               appDate: appDate,
               eval_type: 1,
               figureData:figureDatas.length>0?JSON.stringify(figureDatas):''
            }
            commitCase(param)
            .then(res=>{
               res = checkLogin(res);
                if(!res){
                 this.$message({
                   type: 'warning',
                   message: '登录已失效,请重新登录!'
                 }) 
                  // 登陆已失效 清除登陆状态
                  setTimeout(() => {
                     window.localStorage.removeItem('userToken');
                     window.localStorage.removeItem('sign');
                     window.localStorage.removeItem('userData');
                     this.$router.push({ path: '/login'});
                     }, 1000)
                }
               if(res.code == 200){
                // 提交成功,开始下单,调用支付  
                this.$message({
                    type: 'success',
                    message: '提交成功,请确认订单!'
                 })
                 // 查询相关配置
                 this.getOrderConfigData()
                 this.getUserInfoData()
                 setTimeout(()=>{
                  this.orderConfirmVisible = true
                  this.orderForm.eval_type = 1
                  this.orderForm.case_id = res.data.case_id
                  this.orderForm.pay_type = ''
                  this.orderForm.is_use_points = ''
                  this.orderForm.total_fee = ''
                 },1500)
               }
            })
         },
         // 专家评测
         agentEval(){
            let id = this.applyForm.id
            let title = this.applyForm.title
            let type = this.applyForm.type
            let area = this.applyForm.area
            let abstract = this.applyForm.abstract
            let claim = this.applyForm.claim
            let fullText = this.applyForm.fullText
            let appDate = this.applyForm.appDate
            if(title.length <= 0){
               this.$message({
                    type: 'warning',
                    message: '请填写专利名称!'
                 })
               return false
            }
            if(type.length <= 0){
               this.$message({
                    type: 'warning',
                    message: '请选择预申请类型!'
                 })
               return false
            }
            if(area.length <= 0){
               this.$message({
                    type: 'warning',
                    message: '请选择所属领域!'
                 })
               return false
            }
            if(abstract.length <= 0){
               this.$message({
                    type: 'warning',
                    message: '请填写技术摘要!'
                 })
               return false
            }
            if(claim.length <= 0){
               this.$message({
                    type: 'warning',
                    message: '请填写权利要求!'
                 })
               return false
            }
            if(fullText.length <= 0){
               this.$message({
                    type: 'warning',
                    message: '请填写技术方案!'
                 })
               return false
            }
            let figureData = this.fileList
            let figureDatas = []
            if(figureData&&figureData.length>0){
               figureData.forEach((item,index)=>{
                  figureDatas.push(item.figure_url)
               })
            }
            let param = {
               id: id,
               title: title,
               type: type,
               area: area,
               abstract: abstract,
               claim: claim,
               fullText: fullText,
               appDate: appDate,
               eval_type: 2,
               figureData:figureDatas.length>0?JSON.stringify(figureDatas):''
            }
            commitCase(param)
            .then(res=>{
               res = checkLogin(res);
                if(!res){
                 this.$message({
                   type: 'warning',
                   message: '登录已失效,请重新登录!'
                 }) 
                  // 登陆已失效 清除登陆状态
                  setTimeout(() => {
                     window.localStorage.removeItem('userToken');
                     window.localStorage.removeItem('sign');
                     window.localStorage.removeItem('userData');
                     this.$router.push({ path: '/login'});
                     }, 1000)
                }
               if(res.code == 200){
                // 提交成功,开始下单,调用支付  
                this.$message({
                    type: 'success',
                    message: '提交成功,请确认订单!'
                 })
                 // 查询相关配置
                 this.getOrderConfigData()
                 this.getUserInfoData()
                 setTimeout(()=>{
                  this.orderConfirmVisible = true
                  this.orderForm.eval_type = 2
                  this.orderForm.case_id = res.data.case_id
                  this.orderForm.pay_type = ''
                  this.orderForm.is_use_points = ''
                  this.orderForm.total_fee = ''
                 },1500)
               }
            })
         },
         // 查询订单配置
         getOrderConfigData(){
            let param = {}
            getOrderConfig(param)
            .then(res=>{
               res = checkLogin(res);
                if(!res){
                 this.$message({
                   type: 'warning',
                   message: '登录已失效,请重新登录!'
                 }) 
                  // 登陆已失效 清除登陆状态
                  setTimeout(() => {
                     window.localStorage.removeItem('userToken');
                     window.localStorage.removeItem('sign');
                     window.localStorage.removeItem('userData');
                     this.$router.push({ path: '/login'});
                     }, 1000)
                }
               if(res.code == 200){
                  this.evaluate_fee = res.data.evaluate_fee
                  this.evaluate_agent_fee = res.data.evaluate_agent_fee
               }
            })
         },
         // 查询用户基本信息
         getUserInfoData(){
            let param = {}
            getUserInfo(param)
            .then(res=>{
               res = checkLogin(res);
                if(!res){
                 this.$message({
                   type: 'warning',
                   message: '登录已失效,请重新登录!'
                 }) 
                  // 登陆已失效 清除登陆状态
                  setTimeout(() => {
                     window.localStorage.removeItem('userToken');
                     window.localStorage.removeItem('sign');
                     window.localStorage.removeItem('userData');
                     this.$router.push({ path: '/login'});
                     }, 1000)
                }
               if(res.code == 200){
                  this.points = res.data.points
               }
            })
         },
         // 查询草稿箱信息
         getDraftsData(drafts_id){
            let param = {
               drafts_id
            }
            getDraftsInfo(param)
            .then(res=>{
               res = checkLogin(res);
                if(!res){
                 this.$message({
                   type: 'warning',
                   message: '登录已失效,请重新登录!'
                 }) 
                  // 登陆已失效 清除登陆状态
                  setTimeout(() => {
                     window.localStorage.removeItem('userToken');
                     window.localStorage.removeItem('sign');
                     window.localStorage.removeItem('userData');
                     this.$router.push({ path: '/login'});
                     }, 1000)
                }
               if(res.code == 200){
                  this.applyForm.id = res.data.id
                  this.applyForm.title = res.data.title
                  this.applyForm.area = res.data.area
                  this.applyForm.type = res.data.type
                  this.applyForm.abstract = res.data.abstract
                  this.applyForm.claim = res.data.claim
                  this.applyForm.fullText = res.data.fullText
                  this.fileList = res.data.figureData
                  this.applyForm.appDate = res.data.appDate
               }
            })
         },
         // 提交订单信息,创建订单支付
         commitOrder(){
            let eval_type = this.orderForm.eval_type
            let evaluate_fee = this.evaluate_fee
            let evaluate_agent_fee = this.evaluate_agent_fee
            let data = this.orderForm
            if(eval_type == 1){
               data.total_fee = evaluate_fee
            }else if(eval_type == 2){
               data.total_fee = evaluate_agent_fee
            }
            // 判断订单参数是否完整
            if(data.pay_type.length <= 0 || data.pay_type == 0){
               this.$message({
                    type: 'warning',
                    message: '请选择支付方式!'
                 })
               return false
            }
            if(data.pay_type == 1){
               this.$message({
                    type: 'warning',
                    message: '暂不支持微信支付!'
                 })
               return false
            }
            createOrder(data)
            .then(res=>{
               res = checkLogin(res);
                if(!res){
                 this.$message({
                   type: 'warning',
                   message: '登录已失效,请重新登录!'
                 }) 
                  // 登陆已失效 清除登陆状态
                  setTimeout(() => {
                     window.localStorage.removeItem('userToken');
                     window.localStorage.removeItem('sign');
                     window.localStorage.removeItem('userData');
                     this.$router.push({ path: '/login'});
                     }, 1000)
                }
               if(res.code == 200){
                  // 下单成功
                  this.$message({
                    type: 'success',
                    message: res.msg
                 })
                 this.orderResult = res.data
                 if(res.data.total_fee > 0){
                  // 支付金额大于0,显示支付二维码
                     this.orderCodeVisible = true
                 }else{
                  // 积分全额抵扣,显示积分支付确认页
                     this.confirmPointsVisible = true
                 }
               }else{
                  this.$message({
                    type: 'error',
                    message: res.msg
                 })
               }
            })
         },
         // 积分支付订单
         orderPayUsePoints(){
            let order_sn = this.orderResult.order_sn
            if(order_sn.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '订单号不存在!'
               })
               return false
            }
            let param = { order_sn }
            orderPayByPoints(param)
            .then(res=>{
               if(res.code == 200){
                  this.$message({
                     type: 'success',
                     message: res.msg
                  })
                  this.confirmPointsVisible = false
                  this.orderConfirmVisible = false
                  // 跳转评估记录
                  setTimeout(()=>{
                     this.$router.push({ path: '/customer/evalRecord'});
                  },1000)
               }else{
                  this.$message({
                     type: 'error',
                     message: res.msg
                  })
               }
            })
         },
         // 查询订单详情
         getOrderInfoData(){
            let order_sn = this.orderResult.order_sn
            if(order_sn.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '订单号不存在!'
               })
               return false
            }
            let param = { order_sn }
            getOrderInfo(param)
            .then(res=>{
               if(res.code == 200){
                  if(res.data.status == 2){
                     // 支付成功,跳转评估记录
                     this.$message({
                        type: 'success',
                        message: '支付成功!'
                     })
                     this.orderCodeVisible = false
                     this.orderConfirmVisible = false
                     this.stopTimer()
                     // 跳转评估记录
                     setTimeout(()=>{
                        this.$router.push({ path: '/customer/evalRecord'});
                     },1000)
                  }
               }
            })
         },
         // 开始执行定时器
         startTimer(){
            this.intervalId = setInterval(()=>{
               this.getOrderInfoData()
            },2000);
         },
         // 结束定时器
         stopTimer(){
            if(this.intervalId){
               clearInterval(this.intervalId);
               this.intervalId = null;
            }
         },

         // 附图上传开始
         //文件上传前的校验
         beforeUploadFigure(file){
            const that = this
            if (!/\.(jpg|png|jpeg|JPG|PNG)$/.test(file.name)) {
               that.$message({
                  type: 'error',
                  message: '请上传图片'
               })
               return false
            }
         },
         // 文件上传成功时的钩子
         handleUploadFigureSuccess(response, file, fileList){
            if(response.code == 200){
               this.fileList.push(response.data)
            }else{
               this.$message({
                  type: 'error',
                  message: response.msg
               })
               return false
            }
         },
         // 附图上传结束
         // 预览附图
         preview(val){
            let url = val.pre_figure_url
            this.dialogImageUrl = url
            this.dialogVisible = true
         },
         // 删除图片
         delImg(index){
            this.fileList.splice(index,1)
         },

      }
   }
</script>
<style scoped>
  .login-page {
    text-align: center;
    /* height: 100%; */
  }
  .eval-content {
   width: 1200px;
   /* height: 600px; */
   margin: 0px auto;
   background-color: #fff;
   border-radius: 10px;
  }
  .eval-con-top {
   display: flex;
   margin: 20px 40px;
   padding: 16px 0px;
   border-bottom: 2px solid #eeeeee;
  }
  .eval-con-title {
   color: #2A91DD;
   height: 36px;
   line-height: 36px;
   font-size: 16px;
   font-weight: 700;
  }
  .eval-con-btn {
   width: 120px;
   height: 36px;
   line-height: 36px;
   text-align: center;
   color: #fff;
   font-weight: 700;
   background-color: #2A91DD;
   border-radius: 5px;
   margin-left: 20px;
   cursor: pointer;
  }
  .eval-form {
   width: 1120px;
   margin: 0px auto;
  }
  .eval-form>>>.el-form-item__label {
   text-align: left !important;
   font-weight: 700 !important;
   padding-left: 10px !important;
  }
  .eval-type {
   display: flex;
  }
  .eval-type-item {
   width: 480px;
   color: #666666;
   background-color: #F3F3F3;
   cursor: pointer;
   border-radius: 4px;
  }
  .eval-type-active {
   width: 480px;
   color: #FFFFFF;
   background-color: #2A91DD;
   cursor: pointer;
   border-radius: 4px;
  }
  .eval-area {
   display: flex;
  }
  .eval-area-item{
   width: 126px;
   color: #666666;
   background-color: #F3F3F3;
   cursor: pointer;
   border-radius: 4px;
  }
  .eval-area-active{
   width: 126px;
   color: #FFFFFF;
   background-color: #2A91DD;
   cursor: pointer;
   border-radius: 4px;
  }
  .eval-form>>> .el-input__inner {
   background-color: #F3F3F3 !important;
  }
  .eval-form>>> .el-textarea__inner {
   background-color: #F3F3F3 !important;
   min-height: 80px !important;
  }
 .pay_order_th {
   display: flex;
   align-items: center;
   padding: 0 20px;
   background: #efefef;
   border-radius: 4px;
   font-size: 14px;
   color: #333;
   height: 32px;
 }
 .pay_order {
   padding: 20px;
   width: 690px;
   background: #fff;
   box-shadow: 0 5px 10px #cec7e0a8;
   border-radius: 10px;
 }
 .pay_order_tr {
   display: flex;
   align-items: center;
   padding: 0 20px;
   font-size: 14px;
   color: #333;
   height: 47px;
   border-bottom: 1px solid #efefef;
 }
 .order_count {
   border-top: 1px solid #bdbdbd;
   display: flex;
   align-items: center;
   justify-content: space-between;
   padding: 10px 20px;
 }
 .pay_title {
   display: flex;
   font-size: 16px;
   margin-top: 30px;
   margin-bottom: 20px;
   color: #333;
 }
 .pay_title_bg {
   width: 10px;
   height: 23px;
   background-color: #008d9d;
   border-radius: 4px;
   margin-right: 13px;
 }
 .pay_type_box {
   padding: 24px 20px;
   width: 690px;
   background: #fff;
   box-shadow: 0 5px 10px #cec7e0a8;
   border-radius: 10px;
   display: flex;
   align-items: center;
 }
 .pay_type_item {
   display: flex;
    width: 187px;
    height: 50px;
    border-radius: 10px;
    border: 1px solid #eee;
    margin-right: 20px;
 }
 .pay_type_jf {
   flex: 1;
   height: 50px;
   line-height: 50px;
   text-align: center;
   font-size: 14px;
   color: #333;
 }
 .pay_btn {
   margin-top: 30px;
   display: flex;
   justify-content: flex-end;
 }
 .type_item-right {
   display: flex;
   align-items: center;
   font-size: 14px;
   line-height: 16px;
 }
 .pay_price {
   display: flex;
   flex-direction: column;
   align-items: center;
   padding-top: 30px;
   height: 400px;
 }
 .preview_figure img{
   width: 120px;
   height: 120px;
   margin-right: 10px;
   border: 1px solid #c0ccda;
   border-radius: 6px;
 }
 .img-icon {
   position: absolute;
   background: rgba(0, 0, 0, 0.6);
   top: 0px;
   left: 0px;
   width: 120px;
   height: 120px;
   line-height: 120px;
   cursor: pointer;
   opacity: 0;
   color: #ffffff;
   text-align: center;
}
.img-icon:hover {
   opacity: 1.8;
}
.required-label>>>.el-form-item__label::before{
   content: '* ';
   color: red;
   margin-top: 10px;
}
.required-unlabel>>>.el-form-item__label::before{
   content: '* ';
   color: #ffffff;
   margin-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/views/customer/applyEval.vue